// @flow
export const elements = {
  H: 'H',
  C: 'C',
  O: 'O',
  N: 'N',
  S: 'S',
  F: 'F',
  Cl: 'Cl',
  Br: 'Br',
  P: 'P',
  J: 'J',
};

export const bondsCounts = {
  SINGLE: 'SINGLE',
  DOUBLE: 'DOUBLE',
  TRIPLE: 'TRIPLE',
};

export const diagonalDirections = {
  UP_LEFT: 'UP_LEFT',
  UP_RIGHT: 'UP_RIGHT',
  DOWN_LEFT: 'DOWN_LEFT',
  DOWN_RIGHT: 'DOWN_RIGHT',
};



// WEBPACK FOOTER //
// ./src/app/enums/chemistry.js